import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from "@angular/forms";
import { Subscription, Observable } from "rxjs";
import { UserTinyUrl, TinyUrlService } from "../tinyUrl.Service";
import { SystemService } from "../system.Service";
import { MissionService } from "../MissionService";
import { Router, ActivatedRoute } from '@angular/router';
import { tap, catchError } from 'rxjs/operators';
import { HttpEventType } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { ViewChild } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { MediaService } from '../media.Service';
import { AuthenticationService, Organization } from '../authentication.Service';
import { UserProfile, UserService } from '../user.Service';


@Component({
  selector: 'app-tinyurl-detail',
  templateUrl: './tinyurl-detail.component.html',
  styleUrls: ['./tinyurl-detail.component.css']
})
export class TinyurlDetailComponent implements OnInit {
  sb: MatSnackBarRef<any> | undefined;
  subscription: Subscription;
  firstFormGroup: FormGroup = new FormGroup({});
  secondFormGroup: FormGroup = new FormGroup({});
  thirdFormGroup: FormGroup = new FormGroup({});
  tempTinyUrl?: Observable<UserTinyUrl>;
  tinyUrl: UserTinyUrl = new UserTinyUrl();
  ipAddress: string = "";
  id: string = "";
  success: boolean = false;
  errorMsg: string = "";
  timeout: any | null = null;
  readonly: string = "";
  back: string = "";
  userId: number = 0;
  dialogRef: MatDialogRef<any, any>;
  currentOrganization: Organization = new Organization();
  currentUser: UserProfile = new UserProfile();
  isOrganization: boolean = false;

  @ViewChild('profileDialog') profileDialog: TemplateRef<any>;

  constructor(
    public dialog: MatDialog,
    private snackbar: MatSnackBar,
    private missionService: MissionService,
    private router: Router,
    private actRoute: ActivatedRoute,
    private tinyUrlService: TinyUrlService,
    private systemService: SystemService,
    private mediaService: MediaService,
    private userService: UserService,
    private authenticationService: AuthenticationService
  ) {
    this.back = this.actRoute.snapshot.params.type;
    this.userId = Number(this.actRoute.snapshot.params.userid);
    this.id = this.actRoute.snapshot.params.id;
    systemService.getById("tinyUrl:ipAddress").subscribe(
      result => { this.ipAddress = result.Value; }
    );

    this.subscription = missionService.missionAnnounced$.subscribe(
      mission => {
        if (mission === "Back") {
          this.onSubmit();
        }
      });
  }

  ngOnInit(): void {
    this.success = false;
    this.errorMsg = "";
    this.initForm();
    if (this.id == "0") {
      this.readonly = "";
      this.tinyUrl = new UserTinyUrl();
      this.tinyUrlService.getVerificationCode().subscribe(result => {
        this.tinyUrl.ValidationCode = result.Code;
        this.secondFormGroup.patchValue(this.tinyUrl);
        this.thirdFormGroup.patchValue(this.tinyUrl);
      });
      this.tempTinyUrl = new Observable((observer) => {
        observer.next(this.tinyUrl);
        observer.complete();
      });
      this.userService.getCurrentUser().subscribe({
        next: (result) => {
          this.currentUser = result;
        }
      });
    } else {
      this.readonly = "readonly";
      this.tempTinyUrl = this.tinyUrlService.getTinyUrl(this.id).pipe(tap<UserTinyUrl>(result => {
        this.tinyUrl = result;
        this.firstFormGroup.patchValue(this.tinyUrl);
        this.secondFormGroup.patchValue(this.tinyUrl);
        this.secondFormGroup.controls.ClickThru.setValue(this.tinyUrl.ClickThruLevel != 0);
        this.thirdFormGroup.patchValue(this.tinyUrl);
        this.testUrl(this.tinyUrl.Url);
        if (this.isAdminUser) {
          this.userService.getUser(this.tinyUrl.OwnerId.toString()).subscribe({
            next: (result) => {
              this.currentUser = result;
              this.testUser(this.currentUser.UserID);
            }
          });
        }
        else {
          this.userService.getCurrentUser().subscribe({
            next: (result) => {
              this.currentUser = result;
              this.testUser(this.currentUser.UserID);
            }
          });
        }
      }));
    }
  }

  testUser(userId: number) {
    this.authenticationService.testUserId(userId).subscribe({
      next: (result) => {
        let temp = result as number;
        this.isOrganization = temp != this.userId;
        if (this.isOrganization) {
          this.authenticationService.getOrganization(this.userId).subscribe({
            next: (result) => {
              this.currentOrganization = result
              this.getMediaForProfile();
            }
          });
        }
        else {
          this.getMediaForProfile();
        }
      }
    });
  }

  get isAdminUser(): boolean {
    return this.authenticationService.isAuthorized(['Admin']);
  }

  initForm() {
    this.firstFormGroup = new FormGroup({
      Url: new FormControl()
    });
    this.secondFormGroup = new FormGroup({
      ClickThru: new FormControl(),
      ValidationCode: new FormControl(),
      IsHttps: new FormControl(true)
    });
    this.thirdFormGroup = new FormGroup({
      ClickThruLevel: new FormControl(0)
    });
  }

  checkYourSettings() {
    window.open("http" + (this.secondFormGroup.controls.IsHttps.value ? "s" : "") + "://" + this.firstFormGroup.controls.Url.value + "/test", "_blank");
  }

  get initials() {
    return UserProfile.getInitial((this.isOrganization ? this.currentOrganization?.Name : this.currentUser?.UserName) ?? "");
  }

  imageChangedEvent: any = '';
  croppedImage: any = '';
  media: string = null;

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  private openSnackbar(message: string, action: string) {
    if (action == "") {
      this.snackbar.open(message, action, { duration: 2000 });
    }
    else {
      this.snackbar.open(message, action, { duration: 7000 });
    }
  }

  imageLoaded() {
  }
  cropperReady() {
  }
  loadImageFailed() {
  }
  uploadPicture(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file.size > 1048576) {
        this.openSnackbar("Please upload a picture smaller than 1 MB", "Cancel");
        return;
      }

      const mimeType = file.type;
      if (mimeType.match(/image\/*/) == null) {
        return;
      }

      this.imageChangedEvent = event;
      this.dialogRef = this.dialog.open(this.profileDialog, { height: '390px' });
      this.dialogRef.afterClosed().subscribe(result => {
        if (result == undefined || result == 'no') {
          return;
        }

        let p = 0;
        this.mediaService.uploadBase64FileWithMediaId(this.croppedImage, this.currentUser.MediaId).subscribe(
          event => {
            if (event.type == HttpEventType.UploadProgress)
              p = Math.round(100 * event.loaded / event.total);
            else if (event.type === HttpEventType.Response) {
              this.tinyUrl.MediaId = event.body.MediaID;
              this.getMediaForProfile();
            }
          }, error => {
          });
      });
    }
  }

  getMediaForProfile() {
    if (this.tinyUrl.MediaId == 0) {
      this.media = null;
      return;
    }

    this.mediaService.getMediaById(this.tinyUrl.MediaId).subscribe(
      result => {
        this.media = result
      });
  }

  deleteMediaForProfile() {
    this.tinyUrl.MediaId = 0;
    this.media = null;
  }

  copyFromCode() {
    return this.secondFormGroup.controls.ValidationCode.value;
  }

  verifyDomain(stepper: any) {
    if (this.firstFormGroup.invalid) {
      return;
    }

    this.checkDomain().subscribe(result => {
        this.tinyUrl = result;
        stepper.next();
      });
  }

  checkDomain() {
    this.tinyUrl.Url = this.firstFormGroup.controls.Url.value;
    this.tinyUrl.ValidationCode = this.secondFormGroup.controls.ValidationCode.value;
    return this.tinyUrlService.setTinyUrl(this.tinyUrl);
  }

  checkUrl(event: any) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.errorMsg = "";
      this.success = false;

      const url = this.firstFormGroup.controls.Url.value;
      if (!url) {
        return;
      }
      if (url.trim().length === 0) {
        return;
      }

      this.testUrl(url);
    }, 1000);
  }

  testUrl(url: string) {
    this.tinyUrlService.checkUrl(url, this.id, this.tinyUrl.ValidationCode).subscribe({
      next: (result) => {
        this.errorMsg = "";
        this.success = true;
        this.tinyUrl.Url = url;
        this.tinyUrl.IsValidated = true;
      },
      error: (error) => {
        switch (error.status) {
          case 404:
            this.errorMsg = "This URL has no certificate associated with it";
            break;
          case 302:
            this.errorMsg = "This URL is in use by another account or you have set it up already";
            break;
          case 208:
            this.success = true;
            return;
          case 301:
            this.success = true;
            this.tinyUrl.IsValidated = true;
            this.errorMsg = "The TXT cannot be verified, but the IP resolution is correct";
            return;
          default:
            this.errorMsg = "This URL is not set up in the platform correctly";
            break;
        }

        this.success = false;
      }
    });
  }

  checkClickThru() {
    this.thirdFormGroup.controls.ClickThruLevel.setValue(!this.secondFormGroup.controls.ClickThru.value ? 0 : 1);
  }

  onSubmit() {
    if (this.tinyUrl.Url?.length > 0) {
      this.tinyUrl.OwnerId = this.userId;
      this.tinyUrl.IsHttps = this.secondFormGroup.controls.IsHttps.value;
      this.tinyUrl.ClickThruLevel = this.thirdFormGroup.controls.ClickThruLevel.value;
      this.tinyUrlService.setTinyUrl(this.tinyUrl).subscribe({
        next: (result) => {
          this.goBack();
        },
        error: (error) => {
          console.warn(JSON.stringify(error));
          this.goBack();
        }
      });
    }

  }

  goBack() {
    if (this.back == "profile") {
      this.router.navigate(['profile', this.userId]);
      return;
    }

    this.router.navigate(['edituser', this.userId, 'user'])
  }
}
